import { render, staticRenderFns } from "./DoctorInformationTab.vue?vue&type=template&id=7fa855ee&"
import script from "./DoctorInformationTab.vue?vue&type=script&lang=js&"
export * from "./DoctorInformationTab.vue?vue&type=script&lang=js&"
import style0 from "./DoctorInformationTab.vue?vue&type=style&index=0&id=7fa855ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports